export default "__VITE_ASSET__xp9F$WlD__"